import { post } from "./post";

export const createTestFile = {
    post,
};
